import { OptionType } from '@evinced-private/ui-common';

import { IMobileSdkFilterOptions } from 'src/apps/mobile-sdk/hooks/useMobileSdkFilterOptionsQuery';
import { MOBILE_SDK_TYPES_IDS, MOBILE_SDK_TYPES_MAP } from 'src/common/helpers/MobileQueriesHelper';

import { MobileSdkFilterOptionsQuery } from '../MobileSdkFilterOptions.generated';

const naturalSort = (a: string, b: string): number => {
	return a.localeCompare(b, undefined, {
		numeric: true,
		sensitivity: 'base'
	});
};

const createSortedOptions = (values: string[]): OptionType[] => {
	return values
		.reduce<OptionType[]>((acc, value) => {
			if (value) {
				acc.push({ value, label: value });
			}
			return acc;
		}, [])
		.sort((a, b) => naturalSort(String(a.value), String(b.value)));
};

const createSdkTypeOptions = (values: string[]): OptionType[] => {
	return values
		.reduce<OptionType[]>((acc, sdkType) => {
			if (Boolean(sdkType) && sdkType in MOBILE_SDK_TYPES_MAP) {
				acc.push({
					value: sdkType,
					label: MOBILE_SDK_TYPES_MAP[sdkType as MOBILE_SDK_TYPES_IDS]
				});
			}
			return acc;
		}, [])
		.sort((a, b) => naturalSort(a.label, b.label));
};

export const transformMobileSdkFilterOptionsResults = (
	rawResults: MobileSdkFilterOptionsQuery
): IMobileSdkFilterOptions => {
	const runs = rawResults.msdk_report_runs || [];
	const firstRun = runs[0];

	if (!firstRun) {
		return {
			appName: [],
			appVersion: [],
			sdkType: [],
			sdkVersion: []
		};
	}

	return {
		appName: createSortedOptions(firstRun.app_any || []),
		appVersion: createSortedOptions(firstRun.app_version_any || []),
		sdkType: createSdkTypeOptions(firstRun.sdk_type_group_uniq_array || []),
		sdkVersion: createSortedOptions(firstRun.product_version_any || [])
	};
};
